import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { searchImages } from '../../actions/SearchFieldActions';
import { gridScrollPositionChange, setScrollContainer } from '../../actions/UIActions';
import LinkedList from '../../helpers/LinkedList';
import './GridDisplay.sass';
import SearchingModal from './SearchingModal';
import Image from './Image';

class GridDisplay extends Component {
  constructor(props) {
    super(props);
    this.handleGridScroll = this.handleGridScroll.bind(this);
    this.handleRetrySearch = this.handleRetrySearch.bind(this);
  }

  componentDidMount() {
    const { gridScrollPosition, dispatch } = this.props;
    this.wrapper.scrollTop = gridScrollPosition;
    dispatch(setScrollContainer(this.wrapper));
  }

  handleGridScroll(event) {
    const { scrollTop, scrollHeight, offsetHeight } = event.target;
    const { dispatch } = this.props;
    dispatch(gridScrollPositionChange({ scrollTop, scrollHeight, offsetHeight }));
  }

  handleRetrySearch() {
    const { dispatch } = this.props;
    dispatch(searchImages());
  }

  render() {
    const {
      showAside,
      gridImageSize,
      images,
      searchType
    } = this.props;

    return (
      <div
        ref={(c) => { this.wrapper = c; }}
        onScroll={this.handleGridScroll}
        className={`GridDisplay ${showAside ? 'show-aside' : ''}`}
      >
        {
          searchType === 'IMAGES' ?
            <SearchingModal onRetry={this.handleRetrySearch}>Fetching Images</SearchingModal> :
            undefined
        }
        <div className={`grid-display-wrapper ${gridImageSize}`}>
          { Array.from(images).map((image, i) => <Image key={i} {...image} />) }
        </div>
      </div>
    );
  }
}

GridDisplay.propTypes = {
  showAside: PropTypes.bool.isRequired,
  gridImageSize: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  gridScrollPosition: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchType: PropTypes.string,
  images(props, propName, componentName) {
    if (!LinkedList.isLinkedList(props[propName])) {
      return new Error(
        `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Validation failed.`
      );
    }
    return undefined;
  }
};

GridDisplay.defaultProps = {
  searchType: null,
  images: new LinkedList([])
};

function mapStateToProps({
  UI: {
    gridImageSize,
    gridScrollPosition,
    showAside
  },
  SearchField
}) {
  return {
    showAside,
    gridImageSize,
    gridScrollPosition,
    images: SearchField.imagesSearchResult.images,
    searchType: SearchField.searchType
  };
}

export default connect(mapStateToProps)(GridDisplay);



// WEBPACK FOOTER //
// ./src/containers/Main/GridDisplay.jsx